<template>
  <div v-if="showRequestPermissionAlert && hideCounter !== 0"
    class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-3 flex items-center shadow"
    role="alert"
  >
    <font-awesome-icon icon="exclamation-circle" class="h-5 w-5 text-blue-500"></font-awesome-icon>
    <p class="ml-3 text-sm">
      Para mantenerte informado necesitamos que aceptes las notificaciones
    </p>
    <button @click="requestPermission(); close()" class="bg-blue-500 text-white ml-2 px-2 rounded-lg">Aceptar</button>
  </div>
</template>

<script>
import lmNotifications from '@/mixins/lmNotifications'

export default {
  mixins: [lmNotifications],
  data () {
    return {
      hideCounter: 100000
    }
  },
  methods: {
    close () {
      this.hideCounter = 0
    }
  }
}
</script>
